import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import PSPDFKit from '../pspdfkit';
import {
  getForms,
  sendFormData,
  getDocumentArrayBuffer,
  checkTosCookie,
  setTosCookie
} from '../../api/choiceforms';
import TosModal from './termsofusemodal';

/**
 * need button to save changes/move to the next step
 *   pass in functino so we can call when done
 *
 * url client/order
 * call out to client/fillableforms/order to get list of forms we need to fill out
 * get the first form and display
 * on submit capture data as formid/whatever
 * go to next
 * when done submit to client/fillableform/*orderid
 * redirect to the page that is returned
 */

const baseUrl = `${window.location.protocol}//${window.location.host}/${
  process.env.PUBLIC_URL
}`;

export function FormViewer() {
  const params = useParams();
  const [completedForms, setCompletedForms] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [client, setClient] = useState('');
  const [currentForm, setCurrentForm] = useState(0);
  const [forms, setForms] = useState([]);
  const [finishedLoading, setFinishedLoading] = useState(false);
  const [orderid, setOrderid] = useState('');
  const [pdfContent, setPdfContent] = useState(null);
  const [error, setError] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);

  useEffect(
    () => {
      const loadForms = async () => {
        const orderid = params.superid;
        const client = params.client;
        //look for optional current student param
        let currentStudent = '';
        if (params.currentStudent) {
          currentStudent = params.currentStudent;
        }
        var host = `https://${client}`;
        if (process.env.NODE_ENV === 'development') {
          host = `http://${client}`;
        }
        checkTosCookie(client).then(async response => {
          setShowModal(response === 'invalid');
        });
        try {
          const forms = await getForms(client, orderid, false);
          const currentForm = 0;
          const pdfUrl = `${host}/questions/form/${
            forms[currentForm]
          }?orderid=${orderid}&currentStudent=${currentStudent}`;
          const pdfContent = await getDocumentArrayBuffer(pdfUrl);
          setClient(client);
          setCurrentForm(currentForm);
          setForms(forms);
          setFinishedLoading(true);
          setOrderid(orderid);
          setPdfContent(pdfContent);
        } catch (error) {
          console.log('caught error');
          console.log(error);
          setError(true);
          setErrorMessage(error);
        }
      };

      loadForms();
    },
    [params.superid, params.client, params.currentStudent]
  );

  const acceptTerms = async () => {
    setTosCookie(client);
  };

  const formCompleted = async (formid, xfdf) => {
    console.log('signature');
    // add formd data
    const updatedForms = completedForms;
    updatedForms[formid] = {};
    updatedForms[formid] = xfdf;
    console.log('passing', updatedForms[formid]);
    const nextForm = currentForm + 1;
    let loading = finishedLoading;

    if (nextForm >= forms.length) {
      //finished all the forms... cubmit to the order
      loading = false;
      const result = await sendFormData(client, orderid, updatedForms);
      //on success go to returned url
      window.location = result.returnUrl;
      return;
    }
    var host = `https://${client}`;
    if (process.env.NODE_ENV === 'development') {
      host = `http://${client}`;
    }
    let currentStudent = '';
    if (params.currentStudent) {
      currentStudent = params.currentStudent;
    }
    const pdfUrl = `${host}/questions/form/${
      forms[nextForm]
    }?orderid=${orderid}&currentStudent=${currentStudent}`;
    const pdfContent = await getDocumentArrayBuffer(pdfUrl);

    setCompletedForms({ ...updatedForms });
    setCurrentForm(nextForm);
    setFinishedLoading(loading);
    setPdfContent(pdfContent);
  };

  let licenseKey = process.env.REACT_APP_PSPDFKIT_LICENSE;

  if (finishedLoading) {
    var host = `https://${client}`;
    if (process.env.NODE_ENV === 'development') {
      host = `http://${client}`;
    }
    const title = `Form ${currentForm + 1} of ${forms.length}`;
    const currentFormId = forms[currentForm];
    let imageUrl = host + '/casfiles/choice_fillableform_hero.png';
    if (currentFormId && currentFormId.indexOf('_signeddoc') > 0) {
      imageUrl = host + '/casfiles/signed_document_hero.png';
    }
    return (
      <div
        className="App"
        style={{
          backgroundColor: '#fff',
          maxWidth: '1170px',
          marginRight: 'auto',
          marginLeft: 'auto'
        }}
      >
        <img alt="hero" className={'d-none d-md-block'} src={imageUrl} />
        {error && <div>{errorMessage}</div>}
        {finishedLoading && (
          <PSPDFKit
            documentId={currentForm}
            pdfUrl={pdfContent}
            licenseKey={licenseKey}
            baseUrl={baseUrl}
            completedForm={xfdf => {
              formCompleted(currentFormId, xfdf);
            }}
            hideToolbar={true}
            title={title}
            maxWidth="1170px"
          />
        )}

        <TosModal modal={showModal} onConfirm={acceptTerms} client={client} />
      </div>
    );
  }
  return null;
}

export default FormViewer;
